import { derived } from 'svelte/store'

import fetchStore from '../utilities/fetchStore'

const regex = /\$|\,/g

import { education, studentByDegree } from '../dataPromisesMenu'

export default function () {
  // build our object of data calls for the home page (we imported the ones we need from the 'menu' above)
  const dataCalls = {
    education: education,
    studentByDegree: studentByDegree,
  }

  // This line doesn't look like much, but this function call is what returns the mains Svelte stores after fetching the data.
  const [data, loading, error] = fetchStore(dataCalls)

  // `data` is now a Svelte store. We can build upon the main data store we just created by using `derived()`
  // to create transformations our components can import and use directly.
  // this should be the last place we touch the data before it's dropped into the component.
  const educationDerived = derived(data, ($data)=>{
    if($data.education) {
      return Number(Object.values($data.education)[0])
    } else {
      return 0
    }
  }, 0)
  
  const studentByDegreeDerived = derived(data, ($data)=>{
    if($data.studentByDegree) {
      const entries = Object.entries($data.studentByDegree)
      const itemsArray = entries.map((obj)=>{
        return {label:obj[0], value:obj[1]}
      })
      return itemsArray
    } else {
      return []
    }
  }, [])
  
  return [
    data, 
    loading, 
    error,

    educationDerived,
    studentByDegreeDerived
  ]
}